<div class="wrapper">
  <h3>Upload Identification</h3>
  <p class="id-label">Upload an image of the front of your ID</p>
  <div [ngStyle]="{ 'margin-bottom': '1rem' }" class="body">
    <div *ngIf="!uploadedIdFront" class="uploadPad">
      <form #form class="uploadForm">
        <input
          (change)="onFileEvent($event, 'idFront')"
          (click)="onFileEvent($event, 'idFront')"
          accept=".jpg, .jpeg, .png, .pdf"
          class="upload"
          data-cy="upload-button.component.uploadFile"
          name="myfile"
          type="file"
        />
      </form>
      <span>Drag file here or <span class="browse">Browse</span></span>
      <span class="subtitle">Accepted file types: JPG, PNG, PDF</span>
      <span class="subtitle">Max file size: 20MB</span>
    </div>
    <div [hidden]="uploadedIdFront === null" class="documentsWrapper">
      <div (click)="viewDocument(uploadedIdFront)" class="document">
        <span *ngIf="uploadedIdFront">{{ uploadedIdFront.filename | fileNamePipe }}</span>
        <svg
          class="open"
          fill="none"
          height="16"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <rect fill="url(#pattern0)" fill-opacity="0.5" height="16" width="16" />
          <defs>
            <pattern height="1" id="pattern0" patternContentUnits="objectBoundingBox" width="1">
              <use transform="scale(0.005)" xlink:href="#image0" />
            </pattern>
            <image
              height="200"
              id="image0"
              width="200"
              xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAB7ZJREFUeJzt3U+MXVUdwPFvO2CndWHTQEL8Q4wmglEsdKPGzZAoIWGnrNSFQf4sSIwr3YgLt8YY/ojTonHt0mjUQgChYSvRBmmnhLDBBSHaEqPtQKcubseQsXNm5t3fuefP/X6SsyBhzjvn9H775r25nQeSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJNXr48DDwK+BV4B/ApeBK42OdWANWAVujzumbI4xrHUNuET589vL+d6R4Tyq8RXgJOUPPPc4DhwMOrNIB4FfUP58xowN4ASwHHw2RX0CeJryhzvleIG6IjkIvEj5c4k83y4i+TrwL8ofaImxGnB+UVp/5rjWOB56QhPbB/yQ8odYetTwmuQOyp9DjrFBHee7kEcof4A1jCfHHmSAVcqfQ67x88Bzmsw3KX9wtYwzI88ywhrlzyHXOBt4TsDwrU9Onwb+TCcvoAKsAwcKr+ES8IHCa8gl/Hz3R062xRLwK4xD0wkPP2cg3wA+n3H+Fr1eegHAG6UX0JJcgVwH/CjT3C17tvQCgOdKL0BwL+VfsNU4PjfmUIMcZXhLtPRZ5Bqhcj2DPJBp3pY9Cfy19CKAvzDcnqFCjgDvUv5vkprG89T1ZsUy8CfKn0v1zyA5fI3yh1TT+Bl1xbFpmeGHhr19u1W9n1D+kEqOS8CrwBPU8ZpjJ0cZIj5DG7e7Nx9I1J26jwG3kPetaOVzE8NfFAayxWuM3+S3J1+1IpWKo4lALjBug7+ZfskKVDKOJgJ5j3EbvHv6JStI6TiaCGTsBg9Pv2QFqCGOWQSS+w5jxasljlkEorbUFEcT10/3G9T/1BZHE9dP9xsUUGccTVw/3W9Q1cbRxPXT/QZnruY4mrh+ut/gjNUeRxPXT/cbnKkp4jgbMEf1ut/gDE0Vx4cD5qle9xucmSnjIGCu6nW/wRmZOg4C5qte9xuciRJxEDBn9brf4AyUioOAeavX/QY7VzIOAuauXvcb7FjpOAiYv3rdb7BTNcRBwGNUr/sNdqiWOAh4nOp1v8HO1BQHAY9Vve432JHa4iDg8arX/QY7UWMcBDxm9brfYAdqjYOAx61e9xtsXM1xEPDY1et+gw2rPQ4CHr963W+wUS3EQcAaqtf9BhvUShwErKN63W+wMS3FQcBaqtf9BhvSWhwErKd63W+wES3GAeM+xOdi8FqyMJDyWo0Dxv3ihr9FL8ZPb+rPTQwfGnprxsdYA+4E/p5h7jGf417D59DvyGeQclp+5ti06Oe4bwC3ZVxXGAMpo4c4Nq0usLYnJlhXCAOZXk9xwN4/x/054MBEaxvNQKbVWxybdvM57hsMzxzNxAEGMqVe43i/zc9xf5XhbdyLDO9WPU4jrzm2MpBpzCGOLhlIfsbRMAPJyzgaZyD5GEcHDCQP4+iEgcQzjo4YSCzj6IyBxDGODhlIDOPolIGMZxwdM5BxjKNzBrI445gBA1mMccyEgeydccyIgeyNccyMgeyeccyQgeyOccyUgezMOGbMQNJuxDhmzUC2tx84hXHMmoFs70GMY/YMZHtrGMfsGci13YZxNMdfXj2dY5nmzfmLpGfPQKZzJMOcxpGZgUznP8HzGUejfA1ybSv4mkMYyHaWgQsYx+wZyPZ+inHMnoFs7wbgLYxj1gwkbYXhV/gbx0wZyM7uZPfPJKcYbnBUJwxkd24AHgXe4drncA54AFgqtcBKHAOOM5zH+tWxxvDpU7fnfvB9GeYce5HnWFPNloEvALcAHwTeBl4GTpdcVAUOMXyK1H07/H8ngO8S/3OmbHwG0ViH2Ns/C3gBOFhkpQswEI31S/Z+3awWWekCDERjHGPxayf8NYn3Yqk2D4342gfDVpGRzyAa4xyLXztnohfju1iqzTpw/YivPRC4FgNRdaq6fnwNIiUYiJRgIFKCgUgJBiIlGIiUYCBSgoFICQYiJRiIlGAgUoKBSAkGIiUYiJRgIFKCgUgJBiIlGIiUYCBSgoFICQYiJRiIlGAgUoKBSAkGIiUYiJRgIFKCgUgJBiIlGIiUYCBSgoFICQYiJRiIlGAgUoKBSAkGIiUYiJRgIFKCgUgJBiIl1BjIvtILUDHV/dnXGMjh0gtQMUdKL2CrHIFcHvn1XwpZhVr0xZFf/17IKjI7D1wZMU5S4VOtstsH/JFx184/Jl/1As4xbpNXgO9MvmqV9jDjr5u1yVe9gJOM3+gV4CngM8DStMvXhJYY/oxXiblm/hC9wOuiJwROA3cFzHP/1SHt1unoCXO8SH8pw5zSboRfezleDB8G3gKuzzC3tJ114EbgnchJczyDnAeeyTCvlPIMwXFAvh8UPpVpXmk7J3JMmuvnDUvAWeCTmeaX3u814FbG/5D6/+R6BrkMPJJpbmmrH5AhDsj7E+v9wIt464jyOgWsABs5Js99S8engJeBQ5kfR/P0b+Aow7dYWeS+m3cNuC/zY2i+vkXGOGCa2zheAS4CX57gsTQf32eCd0unus/pJYxEcb4H/Lj0InK4F7hAzI1pjvmN88BX6dzNwO8of9iOtsZvgY8xIysMoWxQ/vAddY4NhmtkhUJq+Jd7HwXuYTiEzwIfAT5Enf9eXvlcZriX6k2G29afB35/9b8lSZIkSZIkSZIkSZIkSZIkSZIkSZIkSarOfwF9Ro6u5v17zAAAAABJRU5ErkJggg=="
            />
          </defs>
        </svg>
        <svg
          (click)="removeDocument('idFront'); $event.stopPropagation()"
          class="delete"
          fill="none"
          height="17"
          viewBox="0 0 17 17"
          width="17"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.5" cy="8.5" fill="#F0F2F9" r="8" stroke="#DBE1ED" />
          <path d="M6 6L10.7472 10.7472" stroke="#9B9EB1" stroke-linecap="round" />
          <path d="M6.00098 10.7471L10.7482 5.99984" stroke="#9B9EB1" stroke-linecap="round" />
        </svg>
      </div>
    </div>
  </div>
  <p class="id-label">Upload an image of the back of your ID</p>
  <div class="body">
    <div *ngIf="!uploadedIdBack" class="uploadPad">
      <form #form1 class="uploadForm">
        <input
          (change)="onFileEvent($event, 'idBack')"
          (click)="onFileEvent($event, 'idBack')"
          accept=".jpg, .jpeg, .png, .pdf"
          class="upload"
          data-cy="upload-button.component.uploadFile"
          name="myfile"
          type="file"
        />
      </form>
      <span>Drag file here or <span class="browse">Browse</span></span>
      <span class="subtitle">Accepted file types: JPG, PNG, PDF</span>
      <span class="subtitle">Max file size: 20MB</span>
    </div>
    <div [hidden]="uploadedIdBack === null" class="documentsWrapper">
      <div (click)="viewDocument(uploadedIdBack)" class="document">
        <span *ngIf="uploadedIdBack"
          >{{ uploadedIdBack.filename | fileNamePipe }}
          <svg
            class="open"
            fill="none"
            height="16"
            viewBox="0 0 16 16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect fill="url(#pattern0)" fill-opacity="0.5" height="16" width="16" />
            <defs>
              <pattern height="1" id="pattern0" patternContentUnits="objectBoundingBox" width="1">
                <use transform="scale(0.005)" xlink:href="#image0" />
              </pattern>
              <image
                height="200"
                id="image0"
                width="200"
                xlink:href="data:image/png;base64,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"
              />
            </defs>
          </svg>
        </span>
        <svg
          (click)="removeDocument('idBack'); $event.stopPropagation()"
          class="delete"
          fill="none"
          height="17"
          viewBox="0 0 17 17"
          width="17"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8.5" cy="8.5" fill="#F0F2F9" r="8" stroke="#DBE1ED" />
          <path d="M6 6L10.7472 10.7472" stroke="#9B9EB1" stroke-linecap="round" />
          <path d="M6.00098 10.7471L10.7482 5.99984" stroke="#9B9EB1" stroke-linecap="round" />
        </svg>
      </div>
    </div>
  </div>
  <div class="buttonWrapper">
    <gcv-button (clickEvent)="cancel()" buttonText="Cancel" type="tertiary"></gcv-button>
    <gcv-button
      (clickEvent)="finish()"
      buttonText="Finish"
      type="primary"
      [disabled]="
        !identificationForm.controls.idFront.valid ||
        !identificationForm.controls.idBack.valid ||
        !(idFrontChanged || idBackChanged)
      "
    ></gcv-button>
  </div>
</div>
